<template>
    <div class="product-categories">
        <div class="product-category text-center" v-for="category in categories" :key="category.Name">
            <router-link :to="'/products/' + category.slug">
                <div class="category-card">
                    <h5>{{category.Name}}</h5>
                    <img :src=category.category_picture.formats.thumbnail.url :alt=category.category_picture.alternativeText >
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "CategoriesContainer",
    data() {
    return {
      loading: true,
    //   categories: []
    };
  },
  props: {
      categories: Array
  },
  mounted() {
    
    // axios.get("https://strapi-asiongs.herokuapp.com/categories", {}).then(
    //   (response) => {
    //     this.categories = response.data;
    //   },
    //   (error) => {
    //     // console.log(error);
    //   }
    // );
    
  },
}
</script>

<style lang="scss" scoped>
.product-categories{
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 24px;

    .product-category{
        transition: 0.2s;
        // border-radius: 4px;
        padding: 16px;
        border: 2px solid #eeeeee;
        

        &:hover{
            cursor: pointer;
            transition: 0.2s;
            box-shadow: 0 10px 30px -16px rgb(0 0 0 / 24%), 0 16px 20px -10px rgb(0 0 0 / 20%);
            transform: translate(0px, -8px);
        }

        .category-card{
            color: #182e5a;
        }
    }
}

@media only screen and (min-width: 600px) {
    .product-categories{
        grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
    }
}

@media only screen and (max-width: 559px) {
    .product-categories{
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }
}

</style>